import React from 'react'
import IneligibleMileage from '../../generic/IneligibleMileage'

import LeftAlignWarn from '../../generic/LeftAlignWarn'
import Error from '../../generic/Error'
import Textbox from '../../generic/floatingText'
export default ({
  inputMileage,
  handleMileage,
  mileage,
  updateVehiclePropNumber,
  isError,
  isIneligible,
  kbbUrl,
  isAdmin,
  isDigitalRetail,
  isCobrandDR,
  vin,
  year,
  make,
  model,
  trim,
  isDisabled,
  isAssigned,
  offerCode,
  isIneligibleVehiclesEnabled,
  mileageWarning
}) => {
  const isInputMileageInvalid = () => {
    if (isIneligibleVehiclesEnabled && isAssigned) return false
    return inputMileage > 300000
  }
  return (
    <>
      <Textbox
        testId="bi-tb-mileage-entry"
        value={inputMileage || ''}
        type={'text'}
        onChange={newValue => handleMileage(newValue)}
        onBlur={newValue => updateVehiclePropNumber('mileage', newValue)}
        label="Mileage"
        id="mileage"
        maxLength={6}
        inputMode={'numeric'}
        pattern={'[0-9]*'}
        autoFocus={true}
        unformatMask={e => {
          return e.replace(/[^\d]+/, '')
        }}
        placeholder="Enter Mileage"
        isError={(!isIneligible && isError) || isInputMileageInvalid()}
        fullWidth={true}
        disabled={isDisabled}
      />
      {mileageWarning && <LeftAlignWarn testId={'bi-lb-mileage-warn'} text={mileageWarning} />}
      {!isIneligible && !isInputMileageInvalid() && <Error isError={isError} testId={'bi-lb-mileage-error'} id={'mileage-error'} text={'Please enter your mileage.'} />}
      <IneligibleMileage isError={isInputMileageInvalid()} detail={'mileage'} testId={'bi-lb-mileage-error'} {...{ kbbUrl, isAdmin, isDigitalRetail, isCobrandDR, year, make, model, trim, inputMileage, vin, isAssigned, offerCode }} />
    </>
  )
}
